"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEventrDto = void 0;
class CreateEventrDto {
    name;
    type;
    stage;
    appPin;
    clientThemeData;
    domain;
    user;
    cmsIp;
    friendlyName;
    itineraryToCopy;
}
exports.CreateEventrDto = CreateEventrDto;
